








import Vue from 'vue';
import Component from 'vue-class-component';

/**
 *
 *  Component that represents that item of a summary.
 *
 *  (i) An item for the summary should be provided as this component.
 *
 */
@Component
export default class SummaryItem extends Vue {}
